var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#92FBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.793 19.54c.913 0 1.761.41 2.326 1.125.557.704.758 1.607.552 2.477l-2.439 10.106a2.94 2.94 0 0 1-2.877 2.243h-8.572c-.888 0-1.77-.152-2.606-.428V19.484a6.095 6.095 0 0 0 1.094-1.51l2.623-5.165c.371-.731 1.088-1.206 1.87-1.24 1.358-.048 2.617.561 3.395 1.643a3.86 3.86 0 0 1 .476 3.634l-1.027 2.695h5.185zm-17.48.001c.862 0 1.59.552 1.868 1.319l.003-.001v13.317l-.003-.001a1.991 1.991 0 0 1-1.868 1.317h-4.486c-1.1 0-1.994-.894-1.994-1.994V21.535c0-1.1.894-1.994 1.994-1.994h4.486zm-2.199 6.3c.55 0 .997-.446.997-.997V23.53a.997.997 0 0 0-1.994 0v1.314c0 .55.447.997.997.997z",
    fill: "#14CC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLike);
export default __webpack_public_path__ + "static/media/homeLike.ced7a7da5e3d2d2237930df554bc5df8.svg";
export { ForwardRef as ReactComponent };